import { DeleteIcon } from "@chakra-ui/icons";
import {
  VStack,
  HStack,
  Divider,
  Collapse,
  useDisclosure,
  Text,
  Button,
  Avatar,
} from "@chakra-ui/react";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";
import StarRatings from "react-star-ratings";
import { RootStore } from "../redux/Store";
import DeleteReviewModal from "./DeleteReviewModal";

function ReviewList(props: IReviews) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const userState = useSelector((state: RootStore) => state.user);

  const [showReview, setShowReview] = React.useState(false);

  const handleToggleReview = () => setShowReview(!showReview);

  return (
    <>
      {props?.user && (
        <>
          <HStack
            spacing="2"
            display="flex"
            alignItems="center"
            width="100%"
            id="ReviewList"
          >
            <Avatar
              size="md"
              name={props?.user?.firstName + " " + props?.user?.lastName}
              src={props.user?.profilePicture}
              marginBottom="auto"
            />

            <VStack alignItems="flex-start" width="100%">
              <HStack width="100%">
                <Text fontWeight="bold">
                  {props?.user?.firstName + " " + props?.user?.lastName}
                </Text>
                <Text
                  style={{
                    marginLeft: "auto",
                  }}
                >
                  {moment(props?.date).format("DD MMMM YYYY")}
                </Text>
              </HStack>
              <StarRatings
                starDimension="18px"
                style={{
                  margin: "0",
                  padding: "0",
                }}
                starSpacing="0px"
                starRatedColor="#D10024"
                numberOfStars={5}
                name="rating"
                rating={Number(props.rating)}
              />

              <Collapse startingHeight={25} in={showReview}>
                {props?.review}
              </Collapse>
              <HStack>
                {userState.loggedInUserData?.user?._id === props?.user?._id && (
                  <Button
                    size="sm"
                    onClick={onOpen}
                    width="fit-content"
                    bg="#D10024"
                    color="white"
                    outline="#D10024"
                    border="1px"
                    borderRadius="5px"
                    id={"DeleteButton" + props._id}
                    leftIcon={<DeleteIcon />}
                    _hover={{
                      color: "#D10024",
                      background: "white",
                      outline: "#D10024",
                    }}
                    _focus={{
                      outline: "none",
                      boxShadow: "none",
                      textDecor: "none",
                    }}
                  >
                    Delete
                    <DeleteReviewModal
                      rootId={String(props.rootId)}
                      _id={props._id}
                      isOpen={isOpen}
                      onClose={onClose}
                      deleteFunc={props.deleteFunc}
                      // submitReviewDeleteFunc={}
                    />
                  </Button>
                )}

                <Button
                  size="sm"
                  onClick={handleToggleReview}
                  width="fit-content"
                  bg="white"
                  color="#D10024"
                  outline="#D10024"
                  border="1px"
                  borderRadius="5px"
                  _hover={{
                    color: "white",
                    background: "#D10024",
                    outline: "#D10024",
                  }}
                  _focus={{
                    outline: "none",
                    boxShadow: "none",
                    textDecor: "none",
                  }}
                >
                  Show {showReview ? "Less" : "More"}
                </Button>
              </HStack>
            </VStack>
          </HStack>
          <Divider dashed color="gray" />
        </>
      )}
    </>
  );
}

export default ReviewList;
